import styled, { css } from "styled-components";
import tw from "twin.macro";

import { IChooseProps } from "./Choose";
import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";

export const StyledChoose = styled.button<IChooseProps>`
  ${tw`tw-antialiased tw-align-middle tw-font-medium tw-inline-block tw-leading-none tw-m-0 tw-no-underline`}
  ${tw`tw-select-none tw-cursor-pointer tw-text-center tw-rounded-lg tw-text-theme-700`}
  ${FontStyle}
  ${BoxSizingStyle}
  height: 32px;
  padding: 0 16px;
  transition: all 0.3s ease;
  border: 1px solid var(--border-primary);
  font-size: 13px;
  transition-duration: 0.3s;
  &:hover {
    ${tw`tw-border-primary`}
    box-shadow: inset 0 0 5px 3px var(--color-primary-300);
  }
  ${(props) =>
    props.active &&
    css`
      ${tw`tw-border-primary tw-z-0`}
      background-color: var(--color-primary-300);
    `}
`;

StyledChoose.displayName = "StyledChoose";
